import { connect } from 'react-redux'

import * as Promotions from '../../promotions/selectors'

import { CasinoLobby as Component } from './lobby'

function mapStateToProps(state) {
  return {
    promotions: Promotions.getLobbyBanners(state.promotions),
  }
}

const connector = connect(mapStateToProps)

export const CasinoLobby = connector(Component)
